import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { urler } from '../../router/router-urler';
import KontaktInfo from './kontakt-info';
import { LandbrukPartner } from './landbruk-partner';
import { LivOgHelseComponent } from './liv-og-helse';
import { NaringPartner } from './naring-partner';
import { PartnerComponent } from './partner';
import { partnerUrler } from './partner-urler';

export const Partner: FC = () => {
    const { reiseUrl, kjoretoyUrl, husOgHytteUrl, innboOgEiendelerUrl } = urler();

    return (
        <>
            <Routes>
                <Route path="/" element={<PartnerComponent />} />
                <Route path={partnerUrler.landbruk} element={<LandbrukPartner />} />
                <Route path={partnerUrler.naring} element={<NaringPartner />} />
                <Route path={partnerUrler.livOgHelse} element={<LivOgHelseComponent />} />
                <Route path={partnerUrler.kjoretoy} element={<Navigate replace to={kjoretoyUrl} />} />
                <Route path={partnerUrler.husOgHytte} element={<Navigate replace to={husOgHytteUrl} />} />
                <Route path={partnerUrler.innbo} element={<Navigate replace to={innboOgEiendelerUrl} />} />
                <Route path={partnerUrler.reise} element={<Navigate replace to={reiseUrl} />} />
            </Routes>
            <KontaktInfo />
        </>
    );
};
